import React, { useContext, useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { LanguageContext } from '../context';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0}  {...props} />
))(() => ({
  borderBottom: `0`,
  background: 'none',
  '&::before': {
    display: 'none',
  },
}))

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={props.expanded ? <Remove sx={{ fontSize: '2rem', color: '#3C2E77' }} /> : <Add sx={{ fontSize: '2rem', color: '#3C2E77' }} />}
    {...props}
  />
))(({ theme }) => ({
  background: 'none',
  fontSize: '21px',
  fontWeight: 'bold',
  borderBottom: `1px solid #3C2E77`,
  color: '#3C2E77',
  flexDirection: 'row',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(0deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginRight: theme.spacing(1),
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  fontSize: '1rem',
  textAlign: 'left',
  padding: '1rem',
  color: '#3C2E77',
  borderTop: '1px solid #3C2E77',
}))

function Faq() {
  const { t, extractArrayOfKeys, currentLanguage } = useContext(LanguageContext)

  const [faqData, setFaqData] = useState([])

  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    const sectionKey = 'faq'
    const keyPrefix = 'question'
    const faqKeys = extractArrayOfKeys(sectionKey, keyPrefix)
    setFaqData(faqKeys.map((key) => {
      const keyIndex = key.substring(keyPrefix.length) // remove 'question' prefix to get the index
      return {
        question: t(`faq.question${keyIndex}`),
        answer: t(`faq.answer${keyIndex}`),
      }
    }))
  }, [currentLanguage])

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  }

  return (
    <div className='my-6 content-parent'>
      <h3 className='text-4xl font-semibold mb-20 my-profile-title'>{t("faq.title")}</h3>

      {faqData.map((faq, index) => (
        <Accordion
          key={`panel${index + 1}`}
          expanded={expanded === `panel${index + 1}`}
          onChange={handleChange(`panel${index + 1}`)}
        >
          <AccordionSummary
            expanded={expanded === `panel${index + 1}`}
            aria-controls={`panel${index + 1}d-content`}
            id={`panel${index + 1}d-header`}
          >
            {faq.question}
          </AccordionSummary>
          <AccordionDetails>
            {faq.answer}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  )
}

export default Faq
